export const dailyThemePresets = {
    foods: [
        {
            mood: 'comfort',
            title: '今日饭运：适合吃点暖的',
            subtitle: '今天更适合让熟悉的味道安慰你。',
            favoredTags: ['热乎', '安稳', '家常感', '治愈', '下饭'],
        },
        {
            mood: 'reward',
            title: '今日饭运：适合奖励自己',
            subtitle: '如果今天有点累，那就让这顿更像奖赏。',
            favoredTags: ['奖励局', '隆重', '高规格', '庆祝', '幸福感'],
        },
        {
            mood: 'easy',
            title: '今日饭运：适合省心一点',
            subtitle: '别把精力都花在纠结上，轻松吃好也很重要。',
            favoredTags: ['快手', '省心', '工作日', '经典'],
        },
    ],
    fitness: [
        {
            mood: 'challenge',
            title: '今日练运：适合来点挑战',
            subtitle: '今天的状态更适合认真出汗，别太保守。',
            favoredTags: ['挑战', '史诗', '极限挑战', '爆发', '耐力'],
        },
        {
            mood: 'steady',
            title: '今日练运：适合稳定推进',
            subtitle: '稳住节奏，把基础做扎实也是一种高质量。',
            favoredTags: ['基础', '力量', '稳定', '热身'],
        },
        {
            mood: 'recovery',
            title: '今日练运：适合恢复和舒展',
            subtitle: '今天更适合把身体慢慢带回舒服的节奏。',
            favoredTags: ['恢复', '排酸', '核心', '克制'],
        },
    ],
    cooking: [
        {
            mood: 'homey',
            title: '今日厨运：适合做家常菜',
            subtitle: '今晚的幸福感，适合从熟悉的锅气里长出来。',
            favoredTags: ['家常', '下饭', '温柔', '认真做'],
        },
        {
            mood: 'feast',
            title: '今日厨运：适合做点硬菜',
            subtitle: '今天的厨房气场不错，可以上点主角菜。',
            favoredTags: ['硬菜', '高光', '庆祝', '重磅'],
        },
        {
            mood: 'clean',
            title: '今日厨运：适合清爽一点',
            subtitle: '简单、干净、轻盈，也能让这一餐很舒服。',
            favoredTags: ['清淡', '轻食', '清爽', '轻负担'],
        },
    ],
};

function getDaySeed() {
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = now.getMonth() + 1;
    const dd = now.getDate();
    return `${yyyy}-${mm}-${dd}`;
}

function hashString(input) {
    return input.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
}

export function getDailyTheme(categoryId) {
    const presets = dailyThemePresets[categoryId] ?? [];
    if (!presets.length) {
        return null;
    }

    const seed = hashString(`${categoryId}-${getDaySeed()}`);
    return presets[seed % presets.length];
}
